import { format, parseISO } from 'date-fns';
import { dateFnsFormat } from '@/helpers/dateFns';

const DEFAULT_FORMAT = 'dd.MM.yyyy HH:mm';

export default {
  install(Vue) {
    Vue.filter('fnsFormat', (date, formatString = DEFAULT_FORMAT) => {
      if (!date) return null;
      return format(parseISO(date), formatString);
    });

    Vue.prototype.$dateFnsFormat = {
      ...dateFnsFormat,
    };
  },
};
